import "jquery-lazyload";
export function createLazyLoad($el, opts) {
  return $el.lazyload(opts);
}